import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createProject: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project',
		defaultMessage: 'Create project',
		description:
			'Used as the alt text for an icon button that when used navigates to create project',
	},
	manageProjects: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects',
		defaultMessage: 'Manage projects',
		description: 'Used as the menu-title for the Manage Projects menu link item',
	},
	projects: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects',
		defaultMessage: 'projects',
		description: 'Used as the menu-title for the Projects more actions item',
	},
	createProjectGalaxia: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project-galaxia',
		defaultMessage: 'Create space',
		description:
			'Used as the alt text for an icon button that when used navigates to create project',
	},
	manageProjectsGalaxia: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects-galaxia',
		defaultMessage: 'Manage spaces',
		description: 'Used as the menu-title for the Manage Projects menu link item',
	},
	projectsGalaxia: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects-galaxia',
		defaultMessage: 'spaces',
		description: 'Used as the menu-title for the Projects more actions item',
	},
});
